import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForAudioplayerComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'artist', 'headline', 'cmsState'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'artist',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
  ];
}
